export const updateDatiConsenso = (unDato, actionType)  => {
  return {
	type: actionType,
	unDato,
  }
};
